export default __webpack_public_path__ + "static/media/taloni.9e098ac6.svg";